import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {observable, makeObservable} from 'mobx';
import {Link} from 'react-router-dom';

@observer
export class ActionButton extends React.Component {

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  static propTypes = {
    label: PropTypes.string.isRequired,
    actionType: PropTypes.string,
    linkTo: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    isLoading: PropTypes.bool,
    loadingLabel: PropTypes.string,
    srText: PropTypes.string,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    type: 'button',
    icon: '',
    className: '',
    loadingLabel: 'Loading',
    linkTo: '',
    isLoading: false,
    srText: '',
    disabled: null
  }

  @observable ariaLiveMessage = '';

  handleClick = (e) => {
    if (!this.props.isLoading && this.props.onClick) {
      return this.props.onClick(e);
    }
  }

  render() {
    const ButtonType = this.props.linkTo ? Link : 'button';
    const ariaLiveMessage = this.props.isLoading ? `${this.props.loadingLabel}` + '&hellip;' : '';
    const btnLabel = this.props.isLoading ? `${this.props.loadingLabel}` + '&hellip;' : this.props.label;
    const iconClass = this.props.isLoading ? 'icon-reload spin' : this.props.icon;

    return (<span>
      <span className="sr-only" role="alert" aria-live="assertive">
        {ariaLiveMessage}
      </span>
      <ButtonType to={this.props.linkTo} type={this.props.type} id={this.props.label + '_button'} onClick={this.handleClick} aria-disabled={this.props.isLoading} className={`${this.props.className} ${this.props.isLoading ? 'loading-button btn' : ''}`} disabled={this.props.disabled}>

        {iconClass && <i className={iconClass} aria-hidden="true"></i>}
        <span dangerouslySetInnerHTML={{
            __html: btnLabel
          }}></span>
        {Boolean(this.props.srText) && <span className="sr-only">{this.props.srText}</span>}
      </ButtonType>
    </span>);
  }
}
